import pRetry from "p-retry";

/**
 * Get currency rate by currency code
 * @param {string} currencyCode - Currency code (e.g., "KZT", "RUB")
 * @returns {Promise<{code: string, name: string, value: number}>}
 */
export async function getCurrencyRate(currencyCode) {
    return await pRetry(async () => {
        return await _getCurrencyRate(currencyCode);
    }, { retries: 5 });
}

/**
 * Internal function to get currency rate from API
 * @param {string} currencyCode - Currency code (e.g., "KZT", "RUB")
 * @returns {Promise<{code: string, name: string, value: number}>}
 */
async function _getCurrencyRate(currencyCode) {
    const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/api/currency/${currencyCode}/`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    );

    if (!response.ok) {
        throw new Error(`Failed to fetch currency rate for ${currencyCode}: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return {
        code: data.code,
        name: data.name,
        value: parseFloat(data.value)
    };
}


/**
 * Get all available currencies
 * @returns {Promise<Array<{code: string, name: string, value: number}>>}
 */
export async function getAllCurrencyRates() {
    return await pRetry(async () => {
        return await _getAllCurrencyRates();
    }, { retries: 5 });
}

/**
 * Internal function to get all currency rates from API
 * @returns {Promise<Array<{code: string, name: string, value: number}>>}
 */
async function _getAllCurrencyRates() {
    const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/api/currency/`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    );

    if (!response.ok) {
        throw new Error(`Failed to fetch currency rates: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data.map(item => ({
        code: item.code,
        name: item.name,
        value: parseFloat(item.value)
    }));
}




